// extracted by mini-css-extract-plugin
export default {"notesTabs":"EntityDossierNotes_notesTabs__WcNfL","cardSection":"EntityDossierNotes_cardSection__xZNRj"};